module.exports = __webpack_public_path__ + "static/carbon-modal-3182edb095f7616caf6f5a66d6d57ab1.png";